type IconName = "sound" | "muted" | "plus" | "game" | "chat" | "wallet" | "profile" | "menu" | "lock";

const paths: Record<IconName, React.ReactNode> = {
  sound: (
    <>
      <path d="M5 9v6h4l5 4V5L9 9H5Z" />
      <path d="M17 9a4 4 0 0 1 0 6M19.5 6.5a8 8 0 0 1 0 11" />
    </>
  ),
  muted: (
    <>
      <path d="M5 9v6h4l5 4V5L9 9H5Z" />
      <path d="m18 9 5 6m0-6-5 6" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  game: (
    <>
      <path d="M8 11v6M5 14h6" />
      <path d="M16 13h.01M19 16h.01" />
      <path d="M7 7h10a5 5 0 0 1 4.7 6.7l-1.2 3.4a2.8 2.8 0 0 1-4.6 1.1L14 16h-4l-1.9 2.2a2.8 2.8 0 0 1-4.6-1.1l-1.2-3.4A5 5 0 0 1 7 7Z" />
    </>
  ),
  chat: <path d="M4 5h16v12H9l-5 4V5Z" />,
  wallet: (
    <>
      <path d="M3 6h15a3 3 0 0 1 3 3v10H5a2 2 0 0 1-2-2V6Z" />
      <path d="M3 6a2 2 0 0 1 2-2h12v5M16 13h5" />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  lock: (
    <>
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
    </>
  ),
};

export function StrokeIcon({ name, size = 20 }: { name: IconName; size?: 16 | 20 | 24 }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name]}
    </svg>
  );
}
